import React from 'react';
import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {Tooltip} from '@material-ui/core';
import {TextCheckbox} from 'front-onceforall-core';

// eslint-disable-next-line prefer-arrow-callback
const CheckboxComponent = React.forwardRef(function CheckboxComponent({
  className,
  documentTypeId,
  checked,
  disabled,
  onChange,
  label,
  ...rest
}, ref) {
  return (
    <div
      className={`col-md-3${className}`}
      ref={ref}
      {...rest}
    >
      <TextCheckbox
        key={`p-${documentTypeId}`}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        label={<span className="d-block d-md-none"><Translate value={label}/></span>}
      />
    </div>
  );
});

CheckboxComponent.defaultProps = {
  className: ''
};

CheckboxComponent.propTypes = {
  className: PropTypes.string,
  documentTypeId: PropTypes.number.isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired
};

const Checkbox = ({notEditable, ...rest}) => (
  notEditable ?
    <Tooltip title={<Translate value="project.edit.notEditable"/>}>
      <CheckboxComponent {...rest}/>
    </Tooltip> :
    <CheckboxComponent {...rest}/>
);

Checkbox.propTypes = {
  notEditable: PropTypes.bool
};

export default Checkbox;
